import { Button } from '@mui/material';
import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, redirect: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }
componentDidUpdate(prevProps) {
  if (window.location.pathname !== this.prevPath) {
    this.setState({ hasError: false, redirect: false });
    this.prevPath = window.location.pathname;
  }
}
  handleRedirect = () => {
    this.setState({ redirect: true });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/v0/dashboard" />;
    }

    if (this.state.hasError) {
      return (
        <>
          <h1>Click the button to navigate to the Dashboard</h1>
          <Button onClick={this.handleRedirect}>Dashboard</Button>
        </>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node
};

export default ErrorBoundary;
